var _rect, _rect2, _rect3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 23,
    viewBox: "0 0 53 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4.09985,
    width: 11,
    height: 3.07487,
    rx: 1.53744,
    fill: "#EBF1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.2495,
    width: 19,
    height: 3.07487,
    rx: 1.53744,
    fill: "#EBF1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16.3994,
    width: 9,
    height: 3.07487,
    rx: 1.53744,
    fill: "#EBF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0263 4.83032C25.1313 4.88414 25.2232 4.9245 25.3019 4.97832C29.3319 7.40016 33.3751 9.822 37.4051 12.2438C38.4684 12.8762 39.5054 12.8897 40.5687 12.2573C44.5856 9.84891 48.6024 7.44053 52.6193 5.03214C52.7243 4.96487 52.8425 4.91105 52.9869 4.83032C53 4.97832 53 5.07251 53 5.16669C53 9.64709 53 14.114 53 18.5944C53 20.7741 51.6348 22.4963 49.587 22.9134C49.2982 22.9672 48.9963 22.9941 48.7075 22.9941C42.2358 22.9941 35.7511 23.0076 29.2794 22.9941C26.8509 22.9807 25.0131 21.1239 25 18.6348C25 14.1275 25 9.62018 25 5.11287C25 5.03214 25.0131 4.93796 25.0263 4.83032Z",
    fill: "#EBF1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7222 1.88365C26.6279 0.618915 27.8225 0 29.319 0C32.4695 0 35.62 0 38.7705 0C42.0653 0 45.3471 0 48.642 0C49.9941 0 51.1099 0.497823 51.9894 1.54729C52.0419 1.61456 52.0944 1.68183 52.1469 1.76256C52.1732 1.80292 52.1863 1.84329 52.2257 1.91056C51.6218 2.27384 51.0442 2.62366 50.4535 2.98694C46.7517 5.22041 43.0499 7.44043 39.348 9.6739C39.0855 9.83536 38.9017 9.82191 38.6523 9.66045C34.491 7.15788 30.3166 4.65531 26.1554 2.15275C26.0241 2.07202 25.8928 1.99129 25.7222 1.88365Z",
    fill: "#EBF1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notification_success.58c17e9abe7c4173e5713a0dc5e9ab10.svg";
export { ForwardRef as ReactComponent };